import type { Quote } from 'receivable-invoices-js/react/api/models/quote';
import type { ReceivableInvoice } from 'receivable-invoices-js/react/api/models/receivable-invoice';
import { QUOTE_STATUSES } from 'receivable-invoices-js/react/constants/quotes';
import { STATUS } from 'receivable-invoices-js/react/constants/invoices';

export const getQuoteCardDate = (quote: Quote): string | null => {
  switch (quote.status) {
    case QUOTE_STATUSES.APPROVED:
      return quote.approvedAt && quote.approvedAt !== '' ? quote.approvedAt : null;
    case QUOTE_STATUSES.CANCELED:
      return quote.canceledAt && quote.canceledAt !== '' ? quote.canceledAt : null;
    default:
      return quote.expiryDate && quote.expiryDate !== '' ? quote.expiryDate : null;
  }
};

export const getQuotes = (quotes: Quote[]) => {
  return quotes.reduce(
    (acc, quote) => {
      if (quote.status === QUOTE_STATUSES.APPROVED || quote.status === QUOTE_STATUSES.CANCELED) {
        acc.completed.push(quote);
      } else {
        acc.attention.push(quote);
      }
      return acc;
    },
    { completed: [] as Quote[], attention: [] as Quote[] }
  );
};

export const getInvoiceCardDate = (invoice: ReceivableInvoice): string | null => {
  switch (invoice.status) {
    case STATUS.PAID:
      return invoice.paidAt && invoice.paidAt !== '' ? invoice.paidAt : null;
    case STATUS.UNPAID:
      return invoice.dueDate && invoice.dueDate !== '' ? invoice.dueDate : null;
    default:
      return invoice.canceledAt && invoice.canceledAt !== '' ? invoice.canceledAt : null;
  }
};

export const getInvoices = (invoices: ReceivableInvoice[]) => {
  return invoices.reduce(
    (acc, invoice) => {
      if (invoice.status === STATUS.PAID || invoice.status === STATUS.CANCELED) {
        acc.completed.push(invoice);
      } else {
        acc.attention.push(invoice);
      }
      return acc;
    },
    { completed: [] as ReceivableInvoice[], attention: [] as ReceivableInvoice[] }
  );
};
